import { RoutesList } from '@bikes/routes/Routes';
import { InsetText } from '@atoms/*';
import { CallToActionCardProps, NavigationLinkObject } from '@molecules/*';
import { BeforeYouStartTemplate, ContentBody } from '@templates';
import { useNavigate } from 'react-router-dom';

type PersonalBikeContentProps = {
  contentTitle: string;
  callToActionCards: CallToActionCardProps[];
  linkObjectArrays: NavigationLinkObject[];
};

export const PersonalBikeContent = ({
  linkObjectArrays,
  callToActionCards,
  contentTitle,
}: PersonalBikeContentProps) => {
  const navigate = useNavigate();

  const weAcceptContent = {
    sectionTitle: 'We accept reports about bikes that:',
    itemList: [
      'look abandoned. It could be rusty, damaged or missing important parts like wheels',
      'have damaged, faulty or missing locks',
    ],
  };

  const needToKnowContent = {
    sectionTitle: `To help us resolve the issue, we need to know:`,
    itemList: [
      `details of the bike (such as brand and colour)`,
      `the location of the bike (include a door number or nearby landmarks like shops)`,
    ],
  };

  const helpfulToIncludeContent = {
    sectionTitle: `It’s useful to provide:`,
    itemList: ['photos of the issue'],
  };

  const bodyContent = [
    weAcceptContent,
    needToKnowContent,
    helpfulToIncludeContent,
  ];

  return (
    <BeforeYouStartTemplate
      contentTitle={contentTitle}
      contentSubtext={
        <>
          <ContentBody content={bodyContent} />
          <InsetText
            content={
              <>
                If you would like to report an issue with a hire bike,{' '}
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(`${RoutesList.BIKES_HOME}?type=hire_bikes`);
                  }}
                  className="text-action-link font-bold underline"
                  rel="noopener noreferrer"
                >
                  report it here
                </a>
                .
              </>
            }
          />
        </>
      }
      callToActionCards={callToActionCards}
      linkObjectArrays={linkObjectArrays}
    />
  );
};
